var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonePhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0A77A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3193 14.7543C14.4478 14.6269 14.5782 14.5012 14.7098 14.3738L14.7572 14.3294C14.8164 14.2702 14.8668 14.2239 14.9047 14.1866C14.9243 14.167 14.9421 14.1493 14.9527 14.1374L14.9581 14.1339L14.9853 14.1066L15.1246 13.9703C18.5142 10.6245 22.9593 8.62157 25.7681 8.1629C26.4957 8.43565 27.157 8.85981 27.7083 9.40733L27.7284 9.42987L27.7504 9.45298C28.5319 10.2541 29.252 11.1131 29.9044 12.0225C29.9299 12.0752 29.9441 12.1048 29.9507 12.1226V12.1327C29.936 12.1647 29.9148 12.1934 29.8884 12.2168C29.8642 12.2406 29.8383 12.2626 29.8108 12.2826L25.5767 15.2337L25.505 15.2793L25.4387 15.3315C25.3468 15.399 24.5557 16.0817 24.2535 15.9158L22.7619 14.5095L22.1338 13.8447L21.0582 14.711C20.3204 15.3036 19.2727 16.1801 18.4698 16.9736C18.3631 17.0784 18.2636 17.1798 18.1628 17.2858L18.1533 17.2935L18.1231 17.3202C17.9495 17.4761 17.764 17.6539 17.569 17.8465C16.823 18.5842 16.5053 18.8669 15.8564 19.4429L14.0899 21.2147L16.0704 23.8299L16.0881 23.8648C16.2292 24.1386 15.5548 24.9066 15.4896 24.9878L15.4363 25.0518L15.3901 25.1217L12.3678 28.6352C12.3448 28.6646 12.3198 28.6925 12.2932 28.7187C12.2595 28.757 12.2173 28.7869 12.1699 28.8058H12.1604C11.3569 28.3832 10.6295 27.8294 10.0081 27.1673L9.98504 27.1472L9.96311 27.127C9.38407 26.3525 8.87519 25.5279 8.44252 24.663C8.3415 24.4691 8.25051 24.2701 8.16992 24.0669C8.64755 21.4547 11.1068 17.9294 14.3193 14.7543Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9148 19.8334C23.2785 21.1121 22.2429 22.1487 20.9648 22.7863",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5602 20.4769C26.2269 23.0994 24.0755 25.2161 21.4316 26.5066",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9789 20.4256C30.1502 22.5786 28.8691 24.5286 27.222 26.1438C25.575 27.7591 23.6004 29.002 21.4316 29.7886",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonePhone);
export default __webpack_public_path__ + "static/media/done-phone.4347c8868b2e991b4810640b7e072bbb.svg";
export { ForwardRef as ReactComponent };